import { createSlice } from '@reduxjs/toolkit';
import { GetBrokers } from './thunks/get-brokers.thunk';
import { BrokersState } from './broker.state';
import { GetBroker } from './thunks/get-broker.thunk';
import { GetBrokersList } from './thunks/get-brokers-list.thunk';

const defaultPageNumber = 1;
const defaultTotalItems = 1;
const defaultPageSize = 5;

const initialState: BrokersState = {
    brokersTable: {
        brokers: [],
        pageNumber: defaultPageNumber,
        totalItems: defaultTotalItems,
        pageSize: defaultPageSize,
    },
    brokersList: [],
    targetBroker: null,
    isLoading: false,
    status: 'succeeded',
    error: '',
};

const brokersSlice = createSlice({
    name: 'brokers',
    initialState,
    reducers: {},
    extraReducers(builder) {
        builder
            .addCase(GetBroker.pending, (state) => {
                setPendingState(state);
            })
            .addCase(GetBroker.rejected, (state) => {
                setRejectedState(state);
            })
            .addCase(GetBroker.fulfilled, (state, action) => {
                const { broker: broker } = action.payload;
                state.targetBroker = broker;
                setSucceededState(state);
            })

            .addCase(GetBrokers.pending, (state) => {
                setPendingState(state);
            })
            .addCase(GetBrokers.rejected, (state) => {
                setRejectedState(state);
            })
            .addCase(GetBrokers.fulfilled, (state, action) => {
                const {
                    brokers: brokers,
                    pageNumber,
                    totalItems,
                    pageSize,
                } = action.payload;
                state.brokersTable.brokers = brokers;
                state.brokersTable.pageNumber = pageNumber;
                state.brokersTable.totalItems = totalItems;
                state.brokersTable.pageSize = pageSize;
                setSucceededState(state);
            })
            
            .addCase(GetBrokersList.pending, (state) => {
                setPendingState(state);
            })
            .addCase(GetBrokersList.rejected, (state) => {
                setRejectedState(state);
            })
            .addCase(GetBrokersList.fulfilled, (state, action) => {
                const { brokersList } = action.payload;
                state.brokersList = brokersList;
                setSucceededState(state);
            });
    },
});

const setRejectedState = (state: any) => {
    state.isLoading = false;
    state.status = 'failed';
    state.error = state;
};

const setPendingState = (state: any) => {
    state.isLoading = true;
    state.status = 'loading';
    state.error = '';
};

const setSucceededState = (state: any) => {
    state.isLoading = false;
    state.status = 'succeeded';
    state.error = '';
};

export const {} = brokersSlice.actions;
export default brokersSlice.reducer;
